// extracted by mini-css-extract-plugin
export default {"channel-header":"Wj4XA","channelHeader":"Wj4XA","channel-logo":"PLBKn","channelLogo":"PLBKn"};